const initialState = {
    get: [], 
    data:[],
    doc:[],
    doc1:[],
    doc2:[],
    doc3:[],
    
  
  };
  
  const SupDocReportsReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_GET_SUCCESS':
            return {... state, get:action.payload};
            case 'FETCH_DATA_SUCCESS':
            return {... state, data:action.payload};
            case 'FETCH_DOC_SUCCESS':
            return {... state, doc:action.payload};
            case 'FETCH_DOC1_SUCCESS':
            return {... state, doc1:action.payload};
            case 'FETCH_DOC2_SUCCESS':
            return {... state, doc2:action.payload};
            case 'FETCH_DOC3SUCCESS':
            return {... state, doc3:action.payload};
            
            
            
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default SupDocReportsReducers;
  
  